import _ from "lodash"
import PropTypes from "prop-types"
import React, {Fragment, Component} from "react"
import { NavLink } from "react-router-dom"
import shop from "shop/shop"
import app from "app.controller";
import { Button } from "elemental-react16"
import Collapsible                                                                    from 'react-collapsible';
import { Icon, Container } from "semantic-ui-react"
import {Link} from "react-router-dom"
import categoryStore               from "stores/categoryStore"
import settingStore from "../../stores/settingStore"
import MediaQuery                                                                                    from "react-responsive"

const NavigationCategories = ( { categories } ) => {
  
  const addLink = function ( category, level ) {
    let children = _.map( category.children, subcat => addLink( subcat, level + 1 ) )
    let parents = getParents( category )
    let parentSegment = (category.parent) ? `/${parents.join( "/" )}` : ""
    let to = `/collection${parentSegment}/${category.map_id}/`
    if(shop.config.plugin && shop.config.plugin.SEOCategoryLink){
      const seoCategory = categoryStore._SEOCategoryTree['/' + parents.map( id => `${id}/` ).join( "" ) + category.map_id];
      to = `/collection/${seoCategory.textpath.substring(1)}`;
      //console.log("SEO Category Tree categoryID", seoCategory,category.map_id, to)
    }

    // if ( !category.active ) return <div key={category.map_id} className={"black-40"}>[OFF] {category.desc.short_des}</div>
    if(level > 1) return null
    if ( !category.active ) return null
    if ( category.isHidden ) return null
    // Add state for hover if level == 1
    const [hovered, setHovered] = React.useState(false);

    // Only attach hover handlers for level 1
    const navLinkProps = level === 1 ? {
      onMouseEnter: () => {
      setHovered(true);
      console.log("Hovered state set to true for category:", category.map_id);
      },
      onMouseLeave: () => {
      setHovered(false);
      console.log("Hovered state set to false for category:", category.map_id);
      }
    } : {};

    return (
      <Fragment key={category.map_id}>
      <div className="fw7 " style={{backgroundColor: "#f1f1f1", border: "none"}} key={category.map_id}>
      {level === 0 && <Link className="categoryLinkSubs f3 fw7 primary" style={{ maxHeight: "60px", display: "flex", alignItems: "center", height: "100%", justifyContent: "start", border: "none" }} to={to} onClick={app.sidebarLeft.close.dispatch}>
        <p className="pa2 mr4 w-40" style={{color: "#369678", borderBottom: "2px solid #369678" }}>{category.desc.short_des}</p>
        </Link>}
      { level === 1 &&
             <NavLink
      style={{
        textDecoration: "none",
        backgroundColor: "#f1f1f1",
        boder: "none",
        paddingLeft: level == 0 ? "0px" : "15px",
        paddingTop: "0px",
        paddingBottom: "0px",
        paddingRight: "10px"
      }}
      className={`NavLinkCat level-${level} cat-${category.map_id}`}
      to={to}
      {...navLinkProps}
      >
      <Button
        as={Link}
        onClick={app.sidebarLeft.close.dispatch}
        className="buttonNavigationSidebar"
        style={{border: "none", backgroundColor: "#f1f1f1"}}
        to={to}
        primary
      >
        <p className="fw6 f5 black-70 hover-primary nowrap ">
        {category.desc.short_des} &nbsp;&nbsp;
        <svg width="6" height="12" viewBox="0 0 4 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M0.119726 1.23959L2.89659 3.99047L0.119726 6.75975C-0.261285 7.12889 0.355442 7.75684 0.737098 7.38769L3.89561 4.24927C3.95926 4.18346 3.99641 4.09582 3.99975 4.00356C4.0031 3.91131 3.9724 3.82113 3.91369 3.75073L0.737098 0.612313C0.356087 0.243165 -0.261285 0.871107 0.119726 1.24026V1.23959Z" fill="#3A3A3A"/>
        </svg>
        </p>
      </Button>
      </NavLink>}
      {/*console.log("category", category, "level", level, "hovered", hovered)*/}
      <MediaQuery minWidth={1200}>
      {level === 1 && hovered && children.length > 0 && (
        
        <div
        className="megaMenuPopup"
        /*          ref={el => {
            if (el) {
              const navLinkElem = el.parentElement.querySelector('.NavLinkCat');
              if (navLinkElem) {
                const rect = navLinkElem.getBoundingClientRect();

                const baseHeight = 200;
                const extraRows = Math.floor(category.children.length / 4);
                const popupHeight = baseHeight + extraRows * 150;

                // Initialposition direkt unter dem NavLink
                let topPos = rect.bottom;

                // Prüfen, ob Popup unten rausclippt
                const bottomEdge = topPos + popupHeight;
                const overflow = bottomEdge - window.innerHeight;

                if (overflow > 0) {
                  // Schiebe das Popup nach oben, aber nicht über den oberen Rand hinaus
                  topPos = Math.max(10, topPos - overflow);
                  el.style.marginTop = '0';
                } else {
                  el.style.marginTop = '-3vw';
                }

                el.style.position = 'fixed';
                el.style.top = `${topPos}px`;
                el.style.left = `${rect.left}px`;
              }
            }
          }}*/
        style={{
          backgroundColor: "#369789",
          position: "absolute",
          left: "100%",
          top: "0%",
          marginLeft: "15vw",
          background: "#ffffff",
          zIndex: 1000,
          minWidth: "20vw",
          height: "100vh",
          paddingLeft: "0.5vw",
          //marginTop: "-1vw",
          // top and maxHeight are set dynamically above
          borderRadius: "8px",
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)} 

        >
                  <Link
            to={to}
            onClick={app.sidebarLeft.close.dispatch}
            className="fw7 f4 categoryLinkSubs" 
            style={{ color: "#369678", textDecoration: "none", border: "none"}}
          >
            <p className="ml2 mr4 w-90 pb2" style={{color: "#369678", borderBottom: "2px solid #369678" }}>{category.title}</p>
          </Link>
        <div className="  ">
          <div className="">
          {category.children.map((subCategory) => {
            
            let parents = getParents(category);
            let parentSegment = (category.parent) ? `/${parents.join("/")}` : "";
            let toChildren = `/collection${parentSegment}/${category.map_id}/`;
            if (shop.config.plugin && shop.config.plugin.SEOCategoryLink) {
              const seoCategory = categoryStore._SEOCategoryTree['/' + parents.map(id => `${id}/`).join("") + category.map_id + '/' + subCategory.map_id];
              toChildren = `/collection/${seoCategory.textpath.substring(1)}`;
              //console.log("SEO Category Tree categoryID", seoCategory, category.map_id, toChildren, '/' + parents.map(id => `${id}/`).join("") + category.map_id + '/' + subCategory.map_id);
            }
          return (
            <Link key={subCategory.map_id} 
              onClick={app.sidebarLeft.close.dispatch}
              className="navigationLinkSubs"
              to={toChildren}
            ><p className="pl3 fw6 f5 black-70 hover-primary nowrap">{subCategory.title}
            &nbsp;&nbsp;
        <svg width="6" height="12" viewBox="0 0 4 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M0.119726 1.23959L2.89659 3.99047L0.119726 6.75975C-0.261285 7.12889 0.355442 7.75684 0.737098 7.38769L3.89561 4.24927C3.95926 4.18346 3.99641 4.09582 3.99975 4.00356C4.0031 3.91131 3.9724 3.82113 3.91369 3.75073L0.737098 0.612313C0.356087 0.243165 -0.261285 0.871107 0.119726 1.24026V1.23959Z" fill="#3A3A3A"/>
        </svg></p>

            </Link>
          )})}
          </div>
        </div>
        </div>
      )}
        </MediaQuery> 
      {/* Render children for other levels as before */}
      {children.length >= 1 && level !== 1 && (
      <div style={{display: "block"}}>
        {children}
      </div>
      )}
      </div>
      </Fragment>
    )
  }
  let cats = _.map( categories, cat => addLink( cat, 0 ) )
  return (
    <div>
      {cats}
    </div>
  )
}

NavigationCategories.propTypes = {
  categories: PropTypes.any
}

const getParents = ( category ) => {
  let ttl = 10
  let parents = []
  while (category && category.parent && ttl--) {
    parents.push( category.parent )
    category = shop.categoriesById.get( category.parent )
  }
  return parents.reverse()
}

let isHovering = false

export class MegaMenuBig extends Component {
  
  state = {
    hover: false,
    index: false,
  }
  
  onLeave = () => {
    isHovering = false
    this.setState( { hover: false } )
    window.setTimeout( () => {
      let { hover } = this.state
      if ( !hover ) this.setState( { index: false } )
    }, 120 )
  }
  
  onHover = ( { index } ) => {
    const DELAY = 300
    isHovering = true
    window.setTimeout( () => {
      if ( isHovering ) this.setState( { index, hover: true } )
    }, DELAY )
  }
  
  render() {
    let { categories } = categoryStore
    const { index } = this.state
    let selectedCategory = shop.categoriesById.get( index )

    return <div
            onMouseLeave={this.onLeave}
            
            className="TopMenuOrtho bg-dark relative" style={{color: "#f5f5f5;", zIndex: 99 }}>
            <Container className="">
              <div className="TopMenuOrtho"></div>
              <div className="">
                {categories.length > 0 &&
                  <div className={"flex flex-row f5 justify-start items-center flex-wrap space-around"}>
                    {categories
                      .map( category => {
                        // console.log( document.location.pathname, `/collection/${category.map_id}/` )
                        const active = document.location.pathname.startsWith( `/collection/${category.map_id}/` ) || selectedCategory && selectedCategory.map_id === category.map_id
                        //console.log("category.children",category.children)
                            return (
                            <Fragment key={category.map_id}>
                              {console.log("index",index)}
                            <Link
                              key={category.map_id}
                              onClick={() => {
                              this.setState({ index: false, hover: false });
                              }}
                              className={` tc db pv3 f2 nowrap fw6 hover-primary black-80 flex-grow-1 ${active ? "active" : ""}`}
                              onMouseEnter={(e) => {
                              this.onHover({ index: category.map_id });
                  
                              }}
                              style={{
                              pointerEvents: this.state.disableHover ? 'none' : 'auto',

                              }}
                              to={`/collection/${category.map_id}/`} ///${additionalLink}
                            >
                              <span className="tc dib pr2 f3 fw7">{category.title}</span>
                            </Link>
                            {selectedCategory  && selectedCategory.children.length > 0  && (<Container
                                        style={{
                                          marginTop: "0",
                                          backgroundColor: "#f5f5f5",
                                          alignContent: "center",
                                          position: "absolute",
                                          top: "100%",
                                        }}
                                        onMouseLeave={this.onLeave}
                                        className="bg-white animate fadeIn variantsContainer flex-grow-1 megaMenuStyle" >
                              <div 
                  
                              >
                              <div>
                              <div className="pa4-ns pa3 pb4  bt b--black-10">
                              <div className="flex flex-row flex-wrap ">
                                {selectedCategory.children.map((subCategory) => {
                                const active = document.location.pathname.startsWith(
                                `/collection/${selectedCategory.map_id}/${subCategory.map_id}/`
                                );
                                return (
                                <div className="pr3 pb4  " key={subCategory.map_id} style={{ flexBasis: "25%" }}>
                                {/*LEVEL II*/}
                                <Link
                                onClick={() => {
                                this.setState({ index: false, hover: false });
                                }}
                                className={`db f4 pv2 pb3 flex-grow-1 b black nowrap fw6 hover-shadow b--black-20 hover-primary categoryLinkSubs ${
                                active ? "active" : ""
                                }`}
                                to={`/collection/${selectedCategory.map_id}/${subCategory.map_id}/`} //${additionalLink}/
                                >
                                <b className="pb2"> 
                                {subCategory.title}
                                {/*<span className="red">({subCategory.sort})</span>*/}
                                </b>
                                <div
                                  style={{ flexBasis: "25%", zIndex: "10000" }}
                                   // onClick={(e) => e.stopPropagation()} Prevent triggering the Link
                                  >
                                  {console.log("subCategory",subCategory)}
                                  {/*<WordPressShopComponent widthOfComponent={true} key={`category-${subCategory.map_id}`} slug={`category-${subCategory.map_id}-megaMenu`}/> */}
                                  <p className="black-50 f6 pt2">
                                  {subCategory.desc.des.substring(0, 40)}{subCategory.desc.des.length > 1 ? "..." : ""}
                                  </p>
                                  </div>
                                  <p className="pt4 black-20 showProducts">
                                  {translate("Produkte ansehen")} ❯
                                  </p>
                                  </Link>
                                  {/*LEVEL III*/}
                                </div>
                                );
                                })}
                              </div>
                              </div>
                              </div>
                              </div></Container>
                            )}
                            </Fragment>
                            );
                      } )
                    }</div>
                    
                }
                   <div className="BotMenuOrtho"></div>         
              </div>
      
            </Container>
          </div>
    }
  }

export default NavigationCategories


// WEBPACK FOOTER //
// ./src/theme/demo2025/components/Navigation/NavigationCategories.js